export default __webpack_public_path__ + "static/gan_faces_better-2934e025a7123258b4dcacb4a132306e.gif";